var map = {
	"./arrows/back-arrow-black.svg": 76747,
	"./arrows/down-chevron-arrow.svg": 34179,
	"./arrows/up-chevron-arrow.svg": 43018,
	"./avatar/avatar-grey.svg": 9870,
	"./blood-pressure-reader-example/blood-pressure-reader-example.png": 86955,
	"./checkmarks/check-box-blank.svg": 44399,
	"./checkmarks/check-circle-purple.svg": 16605,
	"./checkmarks/check-circle-white.svg": 2874,
	"./checkmarks/check-white.svg": 33147,
	"./clinic/clinic.svg": 57577,
	"./delete/trash-grey.svg": 12907,
	"./delete/trash-red.svg": 86651,
	"./edit/edit-grey.svg": 30161,
	"./landing-page/bars.svg": 91594,
	"./landing-page/clouds.svg": 94101,
	"./landing-page/compass.svg": 53317,
	"./landing-page/left-corner-shade.svg": 11040,
	"./landing-page/trees.svg": 56552,
	"./loading/loading.svg": 53698,
	"./logo/ava-logo-blue.png": 44447,
	"./logo/ava-logo-with-ava-title.png": 31905,
	"./logo/ava-logo-without-ava-title.png": 35672,
	"./logo/horizontal-dark-ava-with-logo.png": 85567,
	"./logo/horizontal-light-ava-with-logo.png": 76738,
	"./logo/logo-with-title.svg": 99731,
	"./menu/menu-three-bars-orange.svg": 76335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25640;